import { z } from 'zod';

export const AvailableCurrenciesResponseSchema = z.array(z.string());

export type AvailableCurrenciesResponse = z.infer<typeof AvailableCurrenciesResponseSchema>;
